import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=218707b4&scoped=true&"
import script from "./DashboardItem.vue?vue&type=script&lang=ts&"
export * from "./DashboardItem.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardItem.vue?vue&type=style&index=0&id=218707b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218707b4",
  null
  
)

export default component.exports